import { ChangeDetectionStrategy, Component } from "@angular/core";

import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-enterprise";

@Component({
  standalone: false,
  selector: "app-country-cell-renderer",
  template: `
    @if (!params.value) {
      -
    } @else {
      <img [ngSrc]="ngSrc" class="flag" width="16" height="12" />
      {{ params.value }}
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountryCellRendererComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams;

  public ngSrc: string;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const data = this.getData();

    if (data?.address?.country) {
      this.ngSrc = `assets/images/flags/${data.address.country.toLowerCase()}.svg`;
    }
  }

  refresh(): boolean {
    return false;
  }

  private getData = (): any => this.params.data ?? this.params.node.allLeafChildren[0].data;
}
